"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
const NewEmailView_1 = require("../../../../routes/Private/Emails/EmailHome/NewEmailView");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../../../graphql");
exports.EmailCanvasNewView = () => {
    const { queryParams: { template, version }, } = hooks_1.useEmailCanvasContext();
    const { data: emailTemplateData } = react_hooks_1.useQuery(graphql_1.emailTemplate, {
        skip: !template,
        variables: {
            id: template,
        },
    });
    const { data: emailTemplateVersionData } = react_hooks_1.useQuery(graphql_1.emailTemplateVersion, {
        skip: !template || !version,
        variables: {
            emailTemplateId: template,
            version,
        },
    });
    return (react_2.default.createElement(react_1.OsmosysSmallContainer, { className: "text-center" },
        react_2.default.createElement(NewEmailView_1.NewEmailView, { modalCanClose: false, showModal: true, template: emailTemplateData && emailTemplateData.emailTemplate, templateVersion: emailTemplateVersionData &&
                emailTemplateVersionData.emailTemplateVersion })));
};
//# sourceMappingURL=index.js.map